import type { ModuleManifest } from "./types";

export const contactsManifest: ModuleManifest = {
  name: "contacts",
  label: "Contact",
  labelPlural: "Contacts",

  coreBOSModule: "Contacts",
  wsidPrefix: "12x",

  type: "standard",

  routes: {
    list: "/contacts",
    show: "/contacts/show/:id",
    create: "/contacts/create",
    edit: "/contacts/edit/:id",
  },

  navigation: {
    icon: "TeamOutlined",
    order: 6,
    group: "CRM",
  },

  routing: {
    keywords: ["contact", "contacts", "person", "people", "employee"],
    searchFields: ["firstname", "lastname", "email", "phone"],
    defaultSort: { field: "lastname", order: "asc" },
  },

  context: {
    supported: true,
    entityKey: "contacts",
  },

  fields: [
    { name: "firstname", label: "First Name", type: "string", required: true },
    { name: "lastname", label: "Last Name", type: "string", required: true },
    {
      name: "account_id",
      label: "Account",
      type: "reference",
      referenceModule: "Accounts",
    },
    { name: "title", label: "Title", type: "string" },
    { name: "department", label: "Department", type: "string" },
    { name: "email", label: "Email", type: "string" },
    { name: "phone", label: "Phone", type: "string" },
    { name: "mobile", label: "Mobile", type: "string" },
    {
      name: "leadsource",
      label: "Lead Source",
      type: "picklist",
      options: [
        { value: "Web", label: "Web" },
        { value: "Phone", label: "Phone" },
        { value: "Referral", label: "Referral" },
        { value: "Partner", label: "Partner" },
        { value: "Trade Show", label: "Trade Show" },
        { value: "Other", label: "Other" },
      ],
    },
    { name: "mailingstreet", label: "Mailing Street", type: "string" },
    { name: "mailingcity", label: "Mailing City", type: "string" },
    { name: "mailingstate", label: "Mailing State", type: "string" },
    { name: "mailingzip", label: "Mailing Zip", type: "string" },
    { name: "mailingcountry", label: "Mailing Country", type: "string" },
    { name: "description", label: "Description", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Accounts",
      field: "account_id",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "cbCalendar",
      field: "rel_id",
      relation: "one-to-many",
      label: "Events",
      icon: "CalendarOutlined",
      displayField: "subject",
    },
  ],

  requiredFields: ["lastname", "assigned_user_id"],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
  viewStrategy: "bespoke",
};
